import { Apple } from "@mui/icons-material";
import { getAnalytics, logEvent } from 'firebase/analytics';
import { IOS_APP_STORE_LINK } from "../constants/labels";




const DownloadAppStoreLink = ({ small }) => {
    const analytics = getAnalytics();

    const onClick = () => {
        logEvent(analytics, 'download_appstore_click');
    }

    return (
        <a href={IOS_APP_STORE_LINK} target='_blank' rel="noreferrer">
            <button onClick={onClick}>
                <div
                    className='downloadAppButton blurBackground'
                    style={small ? {
                        width: '34px',
                        height: '34px',
                        padding: '0px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    } : undefined}
                >
                    <Apple style={{ verticalAlign: 'middle', fontSize: small ? '22px' : '60px', color: 'var(--app-text)' }} />
                </div>
            </button>
        </a>
    );
};

export default DownloadAppStoreLink;
